import React from "react";
import leftImg from "../../assets/images/banner-img.jpg";
import rightImg from "../../assets/images/product-img-03.png";
import CustomTable from "../customTable";
import { render } from "@testing-library/react";
import CustomButton from "../customButton";
const CompareCarDetail = () => {
  const columns = [
    {
      title: "Feature",
      dataIndex: "feature",
      key: "feature",
      render: (record) => <p className="font-[500]">{record}</p>,
    },
    {
      title: "SUV",
      dataIndex: "suv",
      key: "suv",
    },
    {
      title: "Toyota",
      dataIndex: "toyota",
      key: "toyota",
    },
  ];

  const dataSource = [
    {
      key: "1",
      feature: "Engine Speed",
      suv: "34,563 cc",
      toyota: "35,533 cc",
    },
    {
      key: "2",
      feature: "Body Type",
      suv: "Convertible",
      toyota: "Hatchback",
    },
    {
      key: "3",
      feature: "Max. Power",
      suv: "140 kW @ 7000 rpm",
      toyota: "142 kW @ 7000 rpm",
    },
    {
      key: "4",
      feature: "Steering",
      suv: "Right",
      toyota: "Left",
    },
    {
      key: "5",
      feature: "Engine Type",
      suv: "1.5 L Gas Engine",
      toyota: "1.55 L Petrol Engine",
    },
    {
      key: "6",
      feature: "No Of Cylinders",
      suv: "04",
      toyota: "04",
    },
    {
      key: "7",
      feature: "Transmission",
      suv: "Automatic",
      toyota: "Manual",
    },
    {
      key: "8",
      feature: "Fuel Type",
      suv: "Petrol",
      toyota: "Gasoline",
    },
  ];

  return (
    <>
      <div className="mt-3 border-1 border-t border-gray"></div>
      <div className="flex justify-between items-center mx-2 sm:mx-4 md:mx-12 pt-6">
        <div className="text-center">
          <img
            className="w-[140px] sm:w-[200px] md:w-[250px] lg:w-[300px] xl:w-[330px] h-[80px] sm:h-[110px] md:h-[140px] lg:h-[160px] xl:h-[180px] m-auto mb-6 rounded rounded-4"
            src={leftImg}
            alt=""
          />
          <p className="text-[14px] md:text-[18px] font-[500]">
            Mercedes-Benz C-Class-2023
          </p>
          <p className="text-[16px] md:text-[20px] font-[700] mb-4">
            $68, 219.000
          </p>
          <CustomButton className="bg-customGreen w-[110px] m-auto h-[35px]">
            View Details
          </CustomButton>
        </div>
        <div>
          <div className="w-[30px] h-[30px] rounded rounded-[100%] bg-customGreen flex justify-center items-center">
            <p>VS</p>
          </div>
          <div className="h-[100px] w-[0.5px] m-auto bg-customGreen"></div>
          <div className="h-[1px] w-[10px] m-auto bg-customGreen"></div>
        </div>

        <div className="text-center">
          <img
            className="w-[140px] sm:w-[160px] md:w-[250px] lg:w-[300px] xl:w-[330px] h-[80px] sm:h-[110px] md:h-[140px] lg:h-[160px] xl:h-[180px] m-auto mb-6 rounded rounded-4"
            src={rightImg}
            alt=""
          />
          <p className="text-[14px] md:text-[18px] font-[500]">
            Mercedes-Benz C-Class-2023
          </p>
          <p className="text-[16px] md:text-[20px] font-[700] mb-4">
            $68, 219.000
          </p>
          <CustomButton className="bg-customGreen w-[110px] m-auto h-[35px]">
            View Details
          </CustomButton>
        </div>
      </div>
      <div className="px-4 mt-14">
        <CustomTable
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </div>
    </>
  );
};

export default CompareCarDetail;
